(function() { window.GUID_449bd44f_31dc_48ec_9311_82c784ceee77 = { getGuid: function() { return "449bd44f-31dc-48ec-9311-82c784ceee77"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Rendered({
                        selector: "body",
                        childSelector: ".accordion-matches-v2",
                        callback: (accordion, e) => {
                            const { isWallLayout } = WallSections.MatchesSection;
                            if (isWallLayout) {
                                WallSections.MatchesSection.setObservers(accordion);
                                //MatchesSection.appendFiltersCounterInTopBar();
                                const $chips = accordion.$Content.find(".chips");
                                if ($chips.length) {
                                    //$chips.css({
                                    //    top: `${Math.floor($("#section-top").outerHeight()) - 1}px`,
                                    //});
                                    $chips.removeClass("hiddenforced");
                                }
                            }
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=matches-section.rendered.js.map
